export default function PHP_real_connect() {
  return (
    <div>
      <h1>PHP_real_connect</h1>
    </div>
  );
}
